module.exports = __webpack_public_path__ + "img/cszq_banner_1_mobile.99a4d9ce.png";